import React from 'react';
import { Typography, Button, Card, CardContent } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card style={{ margin: '20px', maxWidth: '600px' }}>
          <CardContent>
            <Typography variant='h5' color='error' gutterBottom>
              Что-то пошло не так
            </Typography>
            <Typography variant='body1' gutterBottom>
              Произошла ошибка при загрузке компонента. Попробуйте обновить страницу.
            </Typography>
            <Button
              variant='contained'
              color='primary'
              onClick={() => window.location.reload()}
              style={{ marginTop: '10px' }}
            >
              Обновить страницу
            </Button>
            {process.env.NODE_ENV === 'development' && (
              <details style={{ whiteSpace: 'pre-wrap', marginTop: '20px' }}>
                <summary>Детали ошибки (dev mode)</summary>
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
              </details>
            )}
          </CardContent>
        </Card>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
